import type { ReactNode } from 'react'
import { useSettingsStore } from '@/state/useSettingsStore'

interface Props {
  children: ReactNode
  /** Krátké vysvětlení, proč to zatím neplatí. */
  note?: string
  className?: string
}

/**
 * Obal pro dlaždice, které stojí na datech, jimž se ještě nedá věřit.
 * Obsah zůstává na místě (aby se rozvržení nerozpadlo), ale je rozostřený
 * a přebitý poznámkou — nikdo si z něj tedy nemá odnést číslo.
 */
export function NotReady({ children, note, className }: Props) {
  const locale = useSettingsStore((s) => s.locale)
  const cs = locale === 'cs'

  return (
    <div className={`relative ${className ?? ''}`}>
      <div
        aria-hidden
        className="pointer-events-none select-none opacity-40 blur-[6px]"
      >
        {children}
      </div>
      <div className="absolute inset-0 grid place-items-center px-4">
        <div className="rounded-xl border border-border-strong/50 bg-surface-2/90 px-3 py-2 text-center">
          <div className="text-xs font-medium uppercase tracking-[0.14em] text-ink-subtle">
            {cs ? 'Zatím neměříme' : 'Not measured yet'}
          </div>
          {note && <div className="mt-1 max-w-[22ch] text-[11px] text-ink-subtle/70">{note}</div>}
        </div>
      </div>
    </div>
  )
}
